import Alert from 'components/CustomAlert';
/**
 * ReactDOM é um pacote que fornece métodos específicos do DOM que podem
 * ser usados no nível superior do seu aplicativo e como uma saída de 
 * emergencia para sair do modelo React.
 */
import ReactDOM from 'react-dom';

/**
 * Alert é um substituto do `window.alert()` nativo
 * do javascript com a diferença de que esse está
 * estilizado em um modal com a identidade visual
 * do projeto. Apenas um alert por vez pode ser
 * disparado e ele pode ter um callback ao confirmar.
 *
 * @param title {string} Título do cabeçalho do alert, default: "Geobahia informa:"
 * @param message {string|ReactDOM} O que aparecerá no corpo da mensagem do alert
 * @param callback {function} Função que será executada logo após a confirmação do alert
 * @param buttonText {string} Texto que aparecerá no botão
 * @param configInformationalMessage {object} Objeto de configuração da mensagem de informação
 */
/**
 * ReactDOM.render() função recebe dois argumentos, codigo HTML e um 
 * elemento html, a função tem como objetivo exibir o codigo HTML espe-
 * cificado dentro do elemento HTML especificado.
 */
export default ({ title, message, buttonText, callback, configInformationalMessage }) => {
  ReactDOM.render(
    <Alert
      title={title}
      message={message}
      buttonText={buttonText}
      callback={callback}
      configInformationalMessage={configInformationalMessage}
    />,
    document.getElementById('alert')
  );
};